export default function Footer() {
  const footerLinks = [
    {
      title: '核心模块',
      links: [
        { label: '平台优势', href: '#features' },
        { label: '关于我们', href: '#about' },
        { label: '观众热评', href: '#comments' },
        { label: '常见问题', href: '#faq' },
      ],
    },
    {
      title: '内容导航',
      links: [
        { label: '专题推荐', href: '#carousel' },
        { label: '主题索引', href: '#index' },
        { label: '资讯卡片', href: '#cards' },
        { label: '热榜排行', href: '#ranking' },
      ],
    },
    {
      title: '更多入口',
      links: [
        { label: '话题标签', href: '#topics' },
        { label: '媒体库', href: '#media' },
        { label: '更新动态', href: '#updates' },
        { label: '联系我们', href: '#contact' },
      ],
    },
  ];

  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset - 72;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
            <div>
              <a
                href="#hero"
                onClick={(e) => { e.preventDefault(); handleNav('#hero'); }}
                className="flex items-center gap-2 mb-4"
              >
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-movie-2-line text-xl text-white"></i>
                </span>
                <span className="font-heading text-xl font-bold text-background-50">
                  快看影视
                </span>
              </a>
              <p className="text-sm text-background-400 leading-relaxed">
                快看影视致力于提供高清免费电影在线观看服务，电影大全覆盖动作、喜剧、科幻、爱情等多种类型。最新电影免费秒播，流畅高清不卡顿免费看，满足每一位电影爱好者的观影需求。
              </p>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h3 className="text-sm font-semibold text-background-100 mb-4">
                  {group.title}
                </h3>
                <ul className="space-y-2.5">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
                        className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="border-t border-background-800 pt-8">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-background-500">
                &copy; {new Date().getFullYear()} 快看影视 版权所有
              </p>
              <div className="flex items-center gap-4">
                <span className="text-xs text-background-500">合作伙伴</span>
                <span className="text-xs text-background-600">——</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}